var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"options":_vm.langList,"size":"sm"},on:{"change":_vm.langChange},model:{value:(_vm.selectedLang),callback:function ($$v) {_vm.selectedLang=$$v},expression:"selectedLang"}})
}
var staticRenderFns = []

export { render, staticRenderFns }